import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-locators',
  templateUrl: './create-locators.component.html',
  styleUrls: ['./create-locators.component.scss']
})
export class CreateLocatorsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
